var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.activeMapOnLocation)?_c('div',{staticClass:"location-map-helper",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"show-content"},[_vm._v("\n        Visa innehåll\n    ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }